

























































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  SchoolController,
  DropDownController,
  AdminMemberController,
} from '@/services/request.service'
import moment from 'moment'
import debounce from 'lodash/debounce'
import { getAgencyId, getRoleType } from '@/utils/utils'

@Component
export default class SchoolMgmt extends Vue {
  private distributors: Array<any> = []
  private data: any = []
  private loading = false
  private pagination = {
    current: 1,
    defaultCurrent: 1,
    defaultPageSize: 20,
    pageSizeOptions: ['10', '20', '50'],
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: total => this.totalText(total),
  }
  private total = 0

  private moment = moment

  private get roleType(): string {
    return getRoleType()
  }

  private get columns(): any {
    return [
      {
        title: this.$tc('schoolMgmt.schoolCode'),
        dataIndex: 'code',
      },
      {
        title: this.$tc('schoolMgmt.schoolName'),
        scopedSlots: {
          customRender: 'schoolName',
        },
      },
      {
        title: this.$tc('schoolMgmt.teacherNum'),
        dataIndex: 'teacherNum',
      },
      {
        title: this.$tc('schoolMgmt.studentNum'),
        dataIndex: 'studentNum',
      },
      {
        title: this.$tc('schoolMgmt.status'),
        scopedSlots: {
          customRender: 'status',
        },
      },
      {
        title: this.$tc('common.operations'),
        scopedSlots: {
          customRender: 'operations',
        },
      },
    ]
  }

  private get isChildRoute(): boolean {
    return this.$route.name !== 'schoolMgmt'
  }

  private created(): void {
    this.getSchools()
  }

  @Watch('$route', { immediate: true })
  private onRouteChange(to, from): void {
    if (from && from.meta.refresh) {
      this.getSchools()
    }
  }

  private totalText(total): string {
    return this.$tc('schoolMgmt.schoolTotal', total, { total })
  }

  private getDistributors(): void {
    DropDownController.getAgencyList()
      .then(res => {
        this.distributors = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private getSchools(page = {}): void {
    this.loading = true
    const agencyId = parseInt(getAgencyId(), 10)
    const request = {
      pageCurrent: 1,
      pageSize: 20,
      agencyId,
      forAgency: true,
      ...page,
    }
    SchoolController.getPageList(request)
      .then(res => {
        this.data = res.data.items
        this.$set(this.pagination, 'total', res.data.totalItem)
        this.total = res.data.totalItem
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private changeFilter = debounce(() => {
    this.getSchools()
  }, 1000)

  private handleTableChange(pagination): void {
    this.$set(this.pagination, 'current', pagination.current)
    this.$set(this.pagination, 'pageSize', pagination.pageSize)
    const page = {
      pageCurrent: pagination.current,
      pageSize: pagination.pageSize,
    }
    this.getSchools(page)
  }

  private add(): void {
    this.$router.push({ name: 'addSchool' })
  }

  private edit(schoolId): void {
    this.$router.push({ name: 'editSchool', params: { schoolId } })
  }

  private detail(schoolId): void {
    this.$router.push({ name: 'viewSchool', params: { schoolId } })
  }

  private freeze(schoolId): void {
    const request = {
      schoolId,
      freeze: true,
    }
    SchoolController.updateStatus(request)
      .then(res => {
        this.$message.success(this.$tc('common.freezeSuccess'))
        this.getSchools()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private enable(schoolId): void {
    const request = {
      schoolId,
      freeze: false,
    }
    SchoolController.updateStatus(request)
      .then(res => {
        this.$message.success(this.$tc('common.enableSuccess'))
        this.getSchools()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private deleteRecord(schoolId): void {
    SchoolController.delete(schoolId)
      .then(res => {
        this.$message.success(this.$tc('common.deleteSuccess'))
        this.getSchools()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private resetPassword(account, staffId): void {
    this.$confirm({
      title: this.$t('staffMgmt.confirmResetPassword') as string,
      content: h => {
        return h(
          'div',
          {
            style: {
              display: 'flex',
              flexDirection: 'column',
            },
          },
          [
            h('span', this.$t('personal.account') + ': ' + account),
            h('span', this.$t('personal.password') + ': school800'),
          ]
        )
      },
      onOk: () => {
        AdminMemberController.resetPassword(staffId)
          .then(res => {
            this.$message.success(this.$tc('common.resetSuccess'))
          })
          .catch(err => {
            console.error(err)
          })
      },
    })
  }
}
